

const DealerPDFSingle = ({ data, products }) => {

  const getRate = (itemId) => {
    const product = data?.rate.filter(item => item?.itemId === itemId);
    return parseFloat(product[0]?.price) || 0;
  };

  const getIncentive = (itemId) => {
    const product = data?.rate.filter(item => item?.itemId === itemId);
    return parseFloat(product[0]?.inc) || 0;
  };

  const now = new Date();
  const time = now.toLocaleTimeString();
  const formattedDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });


  return (
        <div className="page" style={{maxWidth: '250mm', minWidth: '250mm'}}>
          <div className='row mb-4'>
            <div className='col-12' >
              <div className='card p-4' style={{borderRadius: '20px'}}>
                <h4 className="text-center">Rate Book - <small>{formattedDate} | {time}</small></h4>
                <div className='row m-2 fs-10' style={{border: '1px solid #000'}}>
                  <div className='col-6 text-start' style={{margin: '0px', padding: '10px 15px'}}>
                    <p>
                      DealerId : {data?.id}<br />
                      <b>{data?.dealer}</b><br />
                      <small>{data?.address}</small><br />
                      GSTIN : {data?.gst}<br />
                      PAN : {data?.pan}
                    </p>
                  </div>
                  <div className='col-6 text-end' style={{margin: '0px', padding: '10px 15px'}}>
                    <p>
                      Zone : {data?.zoneData?.zone}<br/>
                      Route : {data?.route}<br/>
                      Place : {data?.location}<br />
                      Contact : {data?.phone}
                    </p>
                </div>
              </div>

              <div className='row m-1' >
                {products?.map(item =>
                  <div className='col-2' style={{margin: '0px', padding: '2px'}}>
                    
                    <table className="table table-bordered fs-10 text-dark text-center" width="100%">
                      <tr>
                        <th colSpan={2} >{item?.productName}</th>
                      </tr>
                      <tr>
                        <td width="50%">Price</td>
                        <td>Incentive</td>
                      </tr>
                      <tr>
                        <td>{Number(getRate(item?.id)).toFixed(2)}</td>
                        <td>{Number(getIncentive(item?.id)).toFixed(2)}</td>
                      </tr>
                    </table>

                  </div>
                )}
              </div>
            </div>
          </div>
        </div> 
      </div>
    );
};

export default DealerPDFSingle;